// removed by extract-text-webpack-plugin
module.exports = {"columnWrapper":"columnWrapper___2q4cL","columnValue":"columnValue___20z4K","deleteColumn":"deleteColumn___3Puvj","inputWrapper":"inputWrapper___3CPY_","checkbox":"checkbox___1rrmD"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/DataSourceSpreadsheet/styles.scss
// module id = 446
// module chunks = 0